import React from 'react';
import styled from 'styled-components';

import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  border: 0.9px solid #636363;

  display: flex;
  padding-left: 15px;

  & input {
    font-family: 'Inter';
    font-size: 14px;
    font-weight: 500;
    background: none;
  }
`;

const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search...',
  height = '50px',
  onClick = () => { },
}) => {
  return (
    <Wrapper>
      <IconButton
        color='rgba(7, 51, 88, 1)'
        type='button'
        sx={{ p: '0px', color: 'rgba(7, 51, 88, 1)' }}
        aria-label='search'
        onClick={onClick}
      >
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{
          ml: 1, flex: 1, width: '85%', height,
          '& .MuiInputBase-input': {
            backgroundColor: 'transparent',
          }
          // bgcolor: 'rgb(240, 255, 240)'
        }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search google maps' }}
        onChange={onChange}
      />
    </Wrapper>
  );
};

export default SearchBar;
